import { ICounterState } from './ICounterState';
import { McAction } from '../../IMcAction';

export function increment(state: ICounterState, action: McAction): ICounterState {
    return Object.assign({}, state, {
        click: state.click + action.payload
    });
}

export function decrement(state: ICounterState, action: McAction): ICounterState {
    return Object.assign({}, state, {
        click: state.click - action.payload
    });
}

export function incrementView(state: ICounterState, action: McAction): ICounterState {
    return Object.assign({}, state, {
        viewCount: state.viewCount * action.payload
    });
}



// WEBPACK FOOTER //
// /home/runner/work/cdg-missioncontrol/cdg-missioncontrol/MissionControlClient2/MissionControl.WebUi2/mc-app/src/app/app-states/modules/counter/counter.reducer.logic.ts